import {makeStyles, Theme} from '@material-ui/core';
import {GRAY, LIGHT_GRAY} from '../../../const/colors';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16
    },
    button: {
        flex: '0 1 250px',
        width: '100%',
        background: 'white',
        border: `1px solid ${LIGHT_GRAY}`,
        color: GRAY,
        textTransform: 'none',
        borderRadius: 3,
        height: 40,
        lineHeight: '16px',
    },
    selectedButton: {
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
    },
    [theme.breakpoints.down('md')]: {
        container: {
             gap: 8
        },
        button: {
            flex: 1,
            width: '100%',
            marginBottom: 8, 
        },
    },
}));

export default useStyles;
